import { useState } from "react";
import { Delete, Edit } from "components/assets/Icons";
import Modal from "components/Modal";
import { ModalAdd, ModalDelete, ModalEdit } from "../Modals";
import Button, { SIZE } from "components/Button";
import UserInfo from "components/UserInfo";
import profilePhoto from "assets/images/profile_photo.svg";
import styles from "./Table.module.scss";

const Table = ({ teamsList, setTeamsList, employeesPhotos }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [modalState, setModalState] = useState("");

  const handleEditClick = (id, name, team_members) => {
    setShowModal(true);
    setModalData({ id, name, members: team_members });
    setModalState("edit");
  };

  const handleAddClick = () => {
    setShowModal(true);
    setModalState("add");
  };

  const handleDeleteClick = (id) => {
    setShowModal(true);
    setModalData(id);
    setModalState("delete");
  };

  return (
    <>
      <Button
        size={SIZE.MIDDLE}
        className={styles.add_button}
        onClick={handleAddClick}
      >
        Add Team
      </Button>

      <div className={styles.wrapper}>
        <div className={styles.content}>
          <div className={styles.header}>
            <div className={styles.row}>
              <div className={styles.cell}>Team</div>
              <div className={styles.cell}>Team Members</div>
            </div>
          </div>
          <div className={styles.body}>
            {teamsList?.map(({ id, name, team_members }) => {
              return (
                <div className={styles.row} key={id}>
                  <div className={styles.cell}>{name}</div>
                  <div className={styles.cell}>
                    {team_members?.map((member, index) => {
                      return (
                        <span className={styles.item} key={index}>
                          <UserInfo
                            src={employeesPhotos.get(member) ?? profilePhoto}
                            name={member}
                          />
                        </span>
                      );
                    })}
                  </div>
                  <div className={styles.group}>
                    <button
                      className={styles.button}
                      onClick={() => handleEditClick(id, name, team_members)}
                    >
                      <Edit />
                    </button>
                    <button
                      className={styles.button}
                      onClick={() => handleDeleteClick(id)}
                    >
                      <Delete />
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {showModal && (
        <Modal
          setShowModal={setShowModal}
          className={styles.modal}
          content={
            modalState === "edit" ? (
              <ModalEdit
                data={modalData}
                setShowModal={setShowModal}
                setTeamsList={setTeamsList}
              />
            ) : modalState === "add" ? (
              <ModalAdd
                setShowModal={setShowModal}
                setTeamsList={setTeamsList}
              />
            ) : modalState === "delete" ? (
              <ModalDelete
                data={modalData}
                setShowModal={setShowModal}
                setTeamsList={setTeamsList}
              />
            ) : (
              <></>
            )
          }
        />
      )}
    </>
  );
};

export default Table;
